/*
 * @Author: Chao Yang
 * @Date: 2020-08-05 02:00:48
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-08-13 01:40:57
 */
import { NgModule, ModuleWithProviders, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdDatePickerComponent } from './ad-date-picker/ad-date-picker.component';
import { AdDatePickerPopupComponent } from './ad-date-picker-popup/ad-date-picker-popup.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule } from '@angular/forms';
import {
  CalendarModule,
  DateAdapter,
  CalendarDateFormatter,
} from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { AdCalendarDateFormatter } from '../ad-calendar-date-formatter.provider';
import {
  AdCommonModule,
} from '../ad-common/ad-common.module';
import { DATE_PICKER_CONFIG_DATA } from './date-picker-config-data';

@NgModule({
  declarations: [AdDatePickerComponent, AdDatePickerPopupComponent],
  imports: [
    CommonModule,
    FormsModule,
    OverlayModule,
    CalendarModule,
    AdCommonModule,
  ],
  exports: [AdDatePickerComponent, AdDatePickerPopupComponent, AdCommonModule],
  // entryComponents: [
  //   AdDatePickerPopupComponent,
  // ],
})
export class AdDatePickerModule {
  static forChild(providers: Provider[]): ModuleWithProviders<AdDatePickerModule> {
    return {
      ngModule: AdDatePickerModule,
      providers,
    };
  }

  static forRoot(providers: Provider[]): ModuleWithProviders<AdDatePickerModule> {
    return {
      ngModule: AdDatePickerModule,
      providers: [
        ...CalendarModule.forRoot(
          {
            provide: DateAdapter,
            useFactory: adapterFactory,
          },
          {
            dateFormatter: {
              provide: CalendarDateFormatter,
              useClass: AdCalendarDateFormatter,
            },
          }
        ).providers,
        ...providers,
      ],
    };
  }
}

export {
  AdDatePickerComponent,
  AdDatePickerPopupComponent,
  DATE_PICKER_CONFIG_DATA,
};
